import homeContent from './content/home.json';

const homeMock = {
    layoutType: 1,
    data: {
        name: 'home',
        layoutType: 1,
        areasList: [
            {
                id: 'home-page-area',
                name: 'Content',
                componentName: 'Comp:HomePage',
                content: JSON.stringify(homeContent),
            },
        ],
    },
};

export default homeMock;
